(() => {
  const initGallery = (root) => {
    if (root.dataset.cdbGalleryReady === 'true') return;
    root.dataset.cdbGalleryReady = 'true';

    const track = root.querySelector('[data-cdb-gallery-track]');
    const slides = [...root.querySelectorAll('[data-cdb-gallery-slide]')];
    const dots = [...root.querySelectorAll('[data-cdb-gallery-dot]')];
    if (!track || slides.length < 2 || dots.length === 0) return;

    const activate = (index) => {
      const safeIndex = Math.max(0, Math.min(index, dots.length - 1));
      dots.forEach((dot, i) => {
        const active = i === safeIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    };

    let raf = 0;
    track.addEventListener('scroll', () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        const width = Math.max(1, track.clientWidth);
        activate(Math.round(track.scrollLeft / width));
        raf = 0;
      });
    }, { passive: true });

    dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = Number(dot.dataset.slideIndex || 0);
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
        activate(index);
      });
    });

    activate(0);
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll('[data-cdb-gallery]').forEach(initGallery);
  };

  document.addEventListener('DOMContentLoaded', () => initAll());
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
